import z from "zod";

export const signInSchema = z.object({
  email: z.string().trim().min(1, "É necessário informar o email!").pipe(z.email("O email deve ser válido")),
  password: z.string().trim().min(1, "É necessário informar a senha!").min(6, "A senha precisa ter o mínimo de 6 caracteres"),
});

export type signInFormData = z.infer<typeof signInSchema>;

export const forgotPasswordEmailSchema = z.object({
  email: z.string().trim().min(1, "É necessário informar o email!").pipe(z.email("O email deve ser válido")),
});

export type ForgotPasswordEmailFormData = z.infer<typeof forgotPasswordEmailSchema>;

export const verifyRecoveryCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, "É necessário informar o código!")
    .regex(/^\d{6}$/, "O código deve conter 6 dígitos"),
});

export type VerifyRecoveryCodeFormData = z.infer<typeof verifyRecoveryCodeSchema>;

export const firstAccessSchema = forgotPasswordEmailSchema.extend({
  code: verifyRecoveryCodeSchema.shape.code,
});

export type FirstAccessFormData = z.infer<typeof firstAccessSchema>;

// Mirrors the backend rule (UserCreateNewPasswordDto): min 8 chars, upper+lower case, number and special char.
const NEW_PASSWORD_RULE = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/;

// Split out for the live password-requirements checklist shown while the user types.
export const passwordLengthSchema = z.string().min(8);
export const passwordCaseSchema = z.string().refine((password) => /[a-z]/.test(password) && /[A-Z]/.test(password));
export const passwordSpecialCharSchema = z.string().refine((password) => /\d/.test(password) && /[^a-zA-Z0-9]/.test(password));

export const newPasswordSchema = z
  .object({
    newPassword: z
      .string()
      .trim()
      .min(1, "É necessário informar a nova senha!")
      .regex(NEW_PASSWORD_RULE, "A senha deve ter no mínimo 8 caracteres, com letra maiúscula, minúscula, número e caractere especial"),
    confirmPassword: z.string().trim().min(1, "É necessário confirmar a nova senha!"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });

export type NewPasswordFormData = z.infer<typeof newPasswordSchema>;
